var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "leftclassroomArrangement" }, [
    _c("div", { staticClass: "title-label" }, [_vm._v("当前课程/会议")]),
    _c("div", { staticClass: "leftpage-content" }, [
      _vm.data.length > 0
        ? _c("div", { staticClass: "swiper-containerFocus" }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.data, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "swiper-slide" },
                  [
                    _c("classroomArrangementItem", {
                      attrs: { item: item, isCurrent: true },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
            _c("div", { staticClass: "swiper-pagination" }),
          ])
        : _c("div", { staticClass: "arrange-nodata" }, [
            _c("div", { staticClass: "content" }, [
              _c("img", {
                attrs: {
                  src: require("_teas/public/img/product/bootScreen/img-null.png"),
                  alt: "",
                  srcset: "",
                },
              }),
              _c("div", { staticClass: "text" }, [_vm._v("暂无当前课程/会议")]),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }